module.exports = __webpack_public_path__ + "img/ic_32_sport_tennis-white.089fdf59.svg";